import key from 'weak-key';

// styles
import styles from './tab-content.module.scss';

// types
import type { ContentElementProps } from 'components/ContentElements/ContentElement';

// components
import { ContentElement } from 'components/ContentElements/ContentElement';

// utils
import { classNameBuilder } from 'utils/classNameBuilder';

type ContentProps = {
  content: ContentElementProps[];
  currentIndex: number;
}

function Content({ content, currentIndex }: Readonly<ContentProps>) {
  if (!content) return null;

  return (
    <div data-preview-id={`#${currentIndex}`}>
      <div data-preview-id="#st_content">
        {content?.map((element, contentIndex) => (
          <div
            key={key(element)}
            className={classNameBuilder(content.length - 1 === contentIndex && styles.lastElement)}
          >
            <ContentElement
              // coding guideline exception: we spread all server props to the component
              {...element}
              key={key(element)}
              contentIndex={contentIndex}
              contentLength={content.length}
              previewId={`#${contentIndex}`}
              childOf="tab"
              isChild
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Content;
